import React from 'react';

import { MessageUI } from '@/api/messaging/types.ts';
import { MessageLabels, MessageTypes } from '@/enums/apiEnums.ts';
import { ViewMessageType } from '@/enums/viewEnums.ts';

export const updateMessageStatusByTempId = (
  setMessagesApi: React.Dispatch<React.SetStateAction<MessageUI[]>>,
  tempId: string,
  patch: Partial<MessageUI>
) => {
  setMessagesApi((prev) =>
    prev.map((m) => (m.status?.id === tempId ? { ...m, ...patch } : m))
  );
};

export const getMessageType = (
  labels: string[],
  type: MessageTypes
): ViewMessageType => {
  const isSystem = labels.includes(MessageLabels.LABEL_SYSTEM);
  const isInbox = labels.includes(MessageLabels.LABEL_INBOX);

  switch (type) {
    case MessageTypes.TYPE_MATCH:
      return ViewMessageType.MATCH;

    case MessageTypes.TYPE_STICKER:
    case MessageTypes.TYPE_ICEBREAKER_GIFT:
      return isInbox ? ViewMessageType.INBOX : ViewMessageType.OUTBOX;

    case MessageTypes.TYPE_TEXT:
    case MessageTypes.TYPE_BAIT:
      if (isSystem) return ViewMessageType.SYSTEM;
      if (isInbox) return ViewMessageType.INBOX;
      return ViewMessageType.OUTBOX;

    default:
      return ViewMessageType.SYSTEM;
  }
};
